import React from 'react';
import './starrating.css'; // Make sure to create this CSS file

const StarRating = ({ rating }) => {
  // Assume rating is a number between 0 and 5 (e.g., 3.5 or 2.2)
  // Calculate the percentage (e.g., 3.5/5 = 70%)
  const percentage = (rating / 5) * 100;
  
  return (
    <div className="star-rating">
      <div className="star-rating__outer">
        {/* These stars represent the empty background */}
        <span>★★★★★</span>
        <div className="star-rating__inner" style={{ width: `${percentage}%` }}>
          {/* These stars will be "filled" (gold) */}
          <span>★★★★★</span>
        </div>
      </div>
    </div>
    

    
  );
};

export default StarRating;
